var _rect, _rect2, _rect3, _rect4, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 62,
    viewBox: "0 0 50 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20.1,
    width: 22,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 26.1,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14.1,
    width: 30,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 60,
    rx: 5,
    stroke: "#2C2D2E",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 47.5,
    r: 5.5,
    stroke: "#2C2D2E",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNjIiIHZpZXdCb3g9IjAgMCA1MCA2MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTAiIHk9IjIwLjEwMDEiIHdpZHRoPSIyMiIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iIzJDMkQyRSIvPgo8cmVjdCB4PSIxMCIgeT0iMjYuMTAwMSIgd2lkdGg9IjE2IiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSIjMkMyRDJFIi8+CjxyZWN0IHg9IjEwIiB5PSIxNC4xMDAxIiB3aWR0aD0iMzAiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiMyQzJEMkUiLz4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjYwIiByeD0iNSIgc3Ryb2tlPSIjMkMyRDJFIiBzdHJva2Utd2lkdGg9IjIiLz4KPGNpcmNsZSBjeD0iMzUuNSIgY3k9IjQ3LjUiIHI9IjUuNSIgc3Ryb2tlPSIjMkMyRDJFIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";
export { SvgInn as ReactComponent };